import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { defer } from 'lodash';
import { connect } from 'react-redux';
import { Link, IconBadge, getTranslation } from '@resy/ui-kitchen';
import { setLocationPath } from '../../../../../ui-kitchen/src/utils/locationUtils';
import './HomepageCollectionsNav.scss';

const GLOBAL_DINING_COLLECTION_SLUG = 'global-dining-access';
const RESY_PLATINUM_COLLECTION_SLUG = 'amex-platinum-nights';

const HomepageCollectionsNav = ({
  collectionList, Analytics, location, $rootScope,
}) => {
  const isLoading = !collectionList;
  const ariaLabel = getTranslation({
    translationKey: 'homepage_collections_nav',
    fallback: 'Collections Nav',
  });

  const skeletonItems = Array.from({ length: 12 }, (_, index) => index);

  if (isLoading) {
    return (
      <div className="HomepageCollectionsNav container" aria-label={ariaLabel} role="region" aria-busy="true">
        <div className="HomepageCollectionsNav__grid">
          {skeletonItems.map((item) => (
            <div key={item} className="HomepageCollectionsNav__item HomepageCollectionsNav__item--skeleton">
              <div className="HomepageCollectionsNav__icon HomepageCollectionsNav__icon--skeleton skeleton" />
              <div className="HomepageCollectionsNav__name HomepageCollectionsNav__name--skeleton skeleton" />
            </div>
          ))}
        </div>
        <hr className="HomepageCollectionsNav__divider" />
      </div>
    );
  }

  if (collectionList.length === 0) return null;

  const filteredCollectionList = collectionList.filter(
    (c) => c.info.collection_slug !== RESY_PLATINUM_COLLECTION_SLUG
  );

  const onClickHandler = (e, collection) => {
    e.preventDefault();
    if (Analytics?.event) {
      Analytics.event('click homepage collection nav',
        { context: 'homepage', value: collection?.info?.name });
    }
    const { search } = window.location;
    const path = `/cities/${location?.url_slug}/list/${collection?.info?.collection_slug}${search}`;
    setLocationPath(
      path,
      () => defer(() => $rootScope?.$apply?.())
    );
  };

  return (
    <div className="HomepageCollectionsNav container" aria-label={ariaLabel} role="region">
      <div className="HomepageCollectionsNav__grid">
        {filteredCollectionList.map((c) => (
          <div key={c.id} className={cx('HomepageCollectionsNav__item', c.info.collection_slug === GLOBAL_DINING_COLLECTION_SLUG && 'HomepageCollectionsNav__item--global-dining')}>
            <Link onClick={(e) => onClickHandler(e, c)}>
              {c.info.image ? (
                <div className="HomepageCollectionsNav__icon">
                  <IconBadge
                    url={c.info.image}
                    bgToSvgRatio="2"
                    size="54"
                  />
                </div>
              ) : null}
              <div className="HomepageCollectionsNav__name">{c.info.short_name || c.info.name}</div>
            </Link>
          </div>
        ))}
      </div>
      <hr className="HomepageCollectionsNav__divider" />
    </div>
  );
};

const homepageCollectionsNavPropTypes = {
  collectionList: PropTypes.arrayOf({}),
  locationCode: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  location: PropTypes.shape({
    url_slug: PropTypes.string,
  }),
  $rootScope: PropTypes.shape({
    $apply: PropTypes.func,
  }),
  isAuthenticated: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  Analytics: PropTypes.shape({ event: PropTypes.func }),
};

HomepageCollectionsNav.propTypes = homepageCollectionsNavPropTypes;

HomepageCollectionsNav.defaultProps = {
  collectionList: undefined,
  locationCode: 'ny',
  location: {},
  $rootScope: {},
  isAuthenticated: false,
  Analytics: {},
};

const mapStateToProps = (state, props) => {
  const {
    isAuthenticated,
    locationCode,
  } = props;

  const key = `${locationCode}-1-${String(isAuthenticated)}`;
  const { collections } = state;

  const all = collections?.lists?.all?.[key]?.all;
  return {
    collectionList: all,
    location: state?.resyLocations?.selected || {},
  };
};

export default connect(mapStateToProps)(HomepageCollectionsNav);
export { HomepageCollectionsNav as ComponentUnderTest, homepageCollectionsNavPropTypes };
